<template>
  <div class="container">
    <div class="header-btns">
      <div class="btn" v-if="canMultiEdit">
        <div
          :class="`mwow-button-filled ${
            multipleSelection.length === 0 ? 'disable' : 'primary'
          }`"
          @click="handleMultiClaim"
        >
          批量认领
        </div>
      </div>
      <div class="btn" v-if="!canMultiEdit">
        <div
          class="mwow-button-filled disable"
          @click="
            () => {
              $message({
                type: 'warning',
                message: '目前规则设置为不允许认领，若需认领，请联系管理员设置',
              });
            }
          "
        >
          批量认领
        </div>
      </div>
      <div class="btn">
        <muti-edit-dialog
          :ori="multipleSelection"
          :hide-potential="true"
          @change="handleRefresh"
        >
          <el-button
            :class="`mwow-button-filled ${
              multipleSelection.length === 0 ? 'disable' : 'success'
            }`"
          >
            批量分配
          </el-button>
        </muti-edit-dialog>
      </div>
      <div class="btn">
        <div
          class="mwow-button-filled primary"
          @click="handleExport"
          v-debounce="5000"
        >
          导出
        </div>
      </div>
      <div class="filter-button" @click="showFilterDialog">
        <img
          src="https://wowsite.musicwow.com/background_manage_frontend/images/store/filter.png"
          width="30"
          class="icon"
        />
        <div>
          <p>统计筛选</p>
          <p class="small">
            (已选{{ activeColumn.length + "/" + columnFilter.length }})
          </p>
        </div>
      </div>
    </div>
    <common-search-form-wrapper :reset="resetSearch">
      <el-form
        size="mini"
        :model="searchInfo"
        label-width="90px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:" prop="sex">
              <el-select
                v-model="searchInfo.sex"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="未知" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="分配次数:"
              prop="allocate_num"
              label-width="115px"
            >
              <div class="allocate-wrap">
                <el-input
                  v-model="searchInfo.allocate_num_start"
                  type="number"
                  placeholder="最低次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_end !== '' &&
                          res > Number(searchInfo.allocate_num_end)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可高于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最低次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_start =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.allocate_num_end"
                  type="number"
                  placeholder="最高次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_start !== '' &&
                          res < Number(searchInfo.allocate_num_start)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可低于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最高次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_end =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最近分配时间:" prop="allocate_time">
              <common-date-range-selector
                v-model="searchInfo.allocate_time"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最近跟进时间:" prop="follow_time">
              <common-date-range-selector
                v-model="searchInfo.follow_time"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="最近跟进课程顾问:"
              prop="last_follow_staff_id"
              label-width="115px"
            >
              <el-select
                v-model="searchInfo.last_follow_staff_id"
                clearable
                @focus="handleChangeFollowStaff('')"
                filterable
                @change="handleSearch"
                placeholder="请选择"
                :filter-method="handleChangeFollowStaff"
              >
                <el-option
                  v-for="item in followStaffList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间:" prop="date">
              <common-date-range-selector
                v-model="searchInfo.date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向:" prop="intent_arr">
              <el-select
                v-model="searchInfo.intent_arr"
                multiple
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="A" key="3" :value="3"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="D" key="0" :value="0"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄分布:" label-width="115px">
              <el-select
                v-model="searchInfo.age_stage"
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="暂无年龄" :value="8"></el-option>
                <el-option label="X ≤ 3" :value="1"></el-option>
                <el-option label="3 < X ≤ 6" :value="2"></el-option>
                <el-option label="6 < X ≤ 9" :value="3"></el-option>
                <el-option label="9 < X ≤ 12" :value="4"></el-option>
                <el-option label="12 < X ≤ 15" :value="5"></el-option>
                <el-option label="15 < X ≤ 18" :value="6"></el-option>
                <el-option label="18 < X" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跟进状态:" prop="follow_status">
              <el-select
                v-model="searchInfo.follow_status"
                multiple
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in followStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="市场顾问:" prop="market_staff_id">
              <el-select
                v-model="searchInfo.market_staff_id"
                placeholder="请输入市场顾问姓名或手机号"
                clearable
                @focus="getMarketStaffList('')"
                filterable
                :filter-method="getMarketStaffList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in marketStaffList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="创建人:"
              prop="create_staff_id"
              label-width="115px"
            >
              <common-staff-pull-down
                :originId.sync="searchInfo.create_staff_id"
                :defaultSelected.sync="searchInfo.create_staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出现方式:" prop="appear_id">
              <el-select
                v-model.number="searchInfo.appear_id"
                filterable
                clearable
                placeholder="请选择"
                @change="
                  () => {
                    searchInfo.source_type = '';
                    sourceList = [];
                    handleSearchSource();
                    handleSearch();
                  }
                "
              >
                <el-option
                  v-for="item in studentAppearLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="来源渠道:" prop="source_type">
              <el-select
                v-model="searchInfo.source_type"
                placeholder="请选择"
                @change="handleSearch"
                clearable
                @focus="
                  () => {
                    if (!searchInfo.appear_id) {
                      $message({
                        type: 'warning',
                        message: '请先选择出现方式',
                      });
                    }
                  }
                "
              >
                <el-option
                  v-for="item in sourceList"
                  :key="item.source_id"
                  :label="item.name"
                  :value="item.source_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      ref="main-table"
      @sort-change="clickStort"
    >
      <el-table-column
        type="selection"
        width="52"
        align="center"
      ></el-table-column>
      <el-table-column
        v-for="item in activeColumn"
        :key="item.key"
        :prop="item.key"
        :label="item.label"
        :min-width="item.key === 'mobile' ? 150 : item.label.length * 16 + 40"
        :sortable="item.sort ? 'custom' : false"
        :sort-orders="item.sort ? ['ascending', 'descending'] : []"
      >
        <template slot-scope="scope">
          <div v-if="item.key === 'name'">
            <div class="mwow-gray" v-if="scope.row.is_del === 1">
              {{ scope.row.name || "-"
              }}<span class="mwow-tag del-filled large">已删除</span>
            </div>
            <div
              v-else
              class="mwow-green"
              style="cursor: pointer"
              @click="toStudentDetail(scope.row)"
            >
              {{ scope.row.name || "-" }}
            </div>
          </div>
          <div v-else-if="item.key === 'mobile'">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p style="text-align: center">
                {{ `${scope.row.wechat_status === 0 ? "未" : "已"}绑定微信` }}
              </p>
              <i
                class="iconfont icon-wechat"
                slot="reference"
                :style="`margin-left:6px;font-size:15px;color:${
                  scope.row.wechat_status === 0 ? '#CCCCCC' : '#01D20B'
                }`"
              ></i>
            </el-popover>
          </div>
          <div v-else-if="item.key === 'sex'">
            <span v-if="scope.row.sex === 0">未知</span>
            <span v-else-if="scope.row.sex === 1">男</span>
            <span v-else-if="scope.row.sex === 2">女</span>
            <span v-else>-</span>
          </div>
          <div v-else-if="item.key === 'follow_staff_id'">
            <span v-if="scope.row.follow_staff_id > 0 && scope.row.stage > 0"
              >已跟进</span
            >
            <span v-if="scope.row.follow_staff_id > 0 && scope.row.stage == 0"
              >待跟进</span
            >
            <span v-if="scope.row.follow_staff_id === 0">未分配</span>
          </div>
          <div v-else-if="item.key === 'stage'">
            {{
              scope.row.follow_stage ? scope.row.follow_stage.name || "-" : "-"
            }}
          </div>
          <div v-else-if="item.key === 'appear_id'">
            {{ handleAppear(scope) }}
          </div>
          <div v-else-if="item.key === 'market_staff'">
            {{
              scope.row.market_staff ? scope.row.market_staff.name || "-" : ""
            }}
          </div>
          <div v-else-if="item.key === 'last_follow_staff'">
            {{
              scope.row.last_follow_staff
                ? scope.row.last_follow_staff.name || "-"
                : "-"
            }}
          </div>
          <div v-else-if="item.key === 'create_staff'">
            {{
              scope.row.create_staff ? scope.row.create_staff.name || "-" : "-"
            }}
          </div>
          <div v-else-if="item.key === 'intent'">
            {{ followLatentObj[scope.row.intent] }}
          </div>
          <div v-else-if="item.key === 'student_source'">
            {{ scope.row.student_source ? scope.row.student_source.name : "-" }}
          </div>
          <div v-else-if="item.key === 'student_subject'">
            <span
              class="dot"
              v-for="item in scope.row.student_subject"
              :key="item.subject_id"
              >{{ item.subject_title || "-" }}</span
            >
            <span
              v-if="
                !scope.row.student_subject ||
                scope.row.student_subject.length === 0
              "
              >-</span
            >
          </div>
          <div v-else>{{ scope.row[item.key] || "-" }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 筛选表格展示项 -->
    <el-dialog
      destroy-on-close
      title="统计筛选"
      :visible.sync="filterDialogVisible"
    >
      <el-form class="mwow-form">
        <el-form-item>
          <el-row>
            <el-col :span="6" v-for="item in columnFilterCopy" :key="item.key">
              <div style="text-align: left">
                <el-checkbox v-model="item.active" :disabled="item.readonly">{{
                  item.label
                }}</el-checkbox>
              </div>
            </el-col>
          </el-row>
          <div style="text-align: center; margin-top: 24px">
            <div
              class="mwow-button-filled"
              style="margin-right: 12px"
              @click="handleFilterDialogCancel"
            >
              取消
            </div>
            <div
              class="mwow-button-filled success"
              @click="handleFilterDialogSubmit"
              type="success"
            >
              确定
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import {
  getWaitingStudentListApi,
  exportWaitingStudentListApi,
  claimWaitingStudentApi,
} from "@/api/studentManage";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import eventBus from "@/utils/bus";
import mutiEditDialog from "../latent/mutiEditDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { getFollowLatentApi } from "@/api/studentFollow";
import { staffList } from "@/api/globalSearch";
import { getMarketStaffListApi } from "@/api/marketActivity";
import { exportLoop } from "@/utils/export";
import { UserModule } from "@/store/module/user";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
export default {
  props: ["visible"],
  components: {
    mutiEditDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
    commonDateRangeSelector,
  },
  data() {
    return {
      showFormSearch: false,
      searchInfo: {
        key_word: "",
        sex: "",
        allocate_num_start: "",
        allocate_num_end: "",
        allocate_time: [],
        follow_time: [],
        appear_id: "",
        source_type: "",
        last_follow_staff_id: "",
        date: [],
        intent_arr: [],
        age_stage: "",
        follow_status: [],
        market_staff_id: "",
        create_staff_id: "",
      },
      sourceList: [],
      tableData: [],
      multipleSelection: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      followLatentObj: {},
      followStaffList: [],
      marketStaffList: [],
      followStatusList: [
        {
          label: "已跟进",
          value: 1,
        },
        {
          label: "未分配",
          value: 2,
        },
        {
          label: "待跟进",
          value: 3,
        },
      ],
      columnFilter: [
        {
          key: "name",
          label: "学员姓名",
          active: true,
          sort: false,
          readonly: true,
        },
        {
          key: "mobile",
          label: "学员手机号",
          active: true,
          sort: false,
          readonly: true,
        },
        {
          key: "sex",
          label: "性别",
          active: true,
          sort: false,
        },
        {
          key: "age",
          label: "年龄",
          active: true,
          sort: true,
        },
        {
          key: "allocate_num",
          label: "分配次数",
          active: true,
          sort: true,
        },
        {
          key: "allocate_time",
          label: "最近分配时间",
          active: true,
          sort: true,
        },
        {
          key: "follow_time",
          label: "最近跟进时间",
          active: true,
          sort: true,
        },
        {
          key: "follow_log_content",
          label: "最近跟进内容",
          active: true,
          sort: false,
        },
        {
          key: "follow_staff_id",
          label: "跟进状态",
          active: true,
          sort: false,
        },
        {
          key: "stage",
          label: "跟进阶段",
          active: true,
          sort: false,
        },
        {
          key: "appear_id",
          label: "出现方式",
          active: true,
          sort: false,
        },
        {
          key: "student_source",
          label: "来源渠道",
          active: true,
          sort: false,
        },
        {
          key: "intent",
          label: "用户意向",
          active: true,
          sort: false,
        },
        {
          key: "student_subject",
          label: "意向科目",
          active: true,
          sort: false,
        },
        {
          key: "market_staff",
          label: "市场顾问",
          active: true,
          sort: false,
        },
        {
          key: "last_follow_staff",
          label: "最近跟进课程顾问",
          active: true,
          sort: false,
        },
        {
          key: "create_staff",
          label: "创建人",
          active: true,
          sort: false,
        },
        {
          key: "create_time",
          label: "创建时间",
          active: true,
          sort: true,
        },
      ],
      columnFilterCopy: [],
      filterDialogVisible: false,
      studentAppearLabelList: [],
    };
  },
  computed: {
    canMultiEdit() {
      return UserModule.userInfo.student_intention_claim_switch === 1;
    },
    activeColumn() {
      return this.columnFilter.filter((item) => {
        return item.active;
      });
    },
  },
  created() {
    this.columnFilterCopy = JSON.parse(JSON.stringify(this.columnFilter));
    eventBus.$on("latent-list-update-waiting", () => {
      const table = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    let filterCache = localStorage.getItem(
      "ts-latent-waiting-data-filter-params"
    );
    if (filterCache) {
      let json = JSON.parse(filterCache);
      this.columnFilter = [...json.filter];
      this.columnFilterCopy = [...json.copy];
    }
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitWaitingList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      getFollowLatentApi().then((res) => {
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followLatentObj = obj;
      });
      getStudentAppearListApi({
        page: 1,
        page_size: 500,
      }).then((res) => {
        this.studentAppearLabelList = res.data.list;
      });
      this.handleRefresh();
    },
    handleAppear(scope) {
      let target = this.studentAppearLabelList.find((item) => {
        return scope.row.appear_id === item.id;
      });
      if (target) {
        return target.name;
      } else {
        return "-";
      }
    },
    handleChangeFollowStaff(v) {
      staffList({
        page: 1,
        page_size: 50,
        key_word: v,
        job_ids: [3],
      }).then((res) => {
        this.followStaffList = res.data.list;
      });
    },
    getMarketStaffList(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.marketStaffList = res.data.list;
        }
      });
    },
    handleSearchSource() {
      if (!this.searchInfo.appear_id) {
        return false;
      }
      sourceTypeSelectListApi({ appear_id: this.searchInfo.appear_id }).then(
        (result) => {
          this.sourceList = result.data.list;
        }
      );
    },
    resetSearch() {
      this.searchInfo = {
        key_word: "",
        sex: "",
        allocate_num_start: "",
        allocate_num_end: "",
        allocate_time: [],
        follow_time: [],
        appear_id: "",
        source_type: "",
        last_follow_staff_id: "",
        date: [],
        intent_arr: [],
        age_stage: "",
        follow_status: [],
        market_staff_id: "",
        create_staff_id: "",
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    solveSearchParams() {
      let option = {};
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.sex !== "") {
        option.sex = this.searchInfo.sex;
      }
      if (this.searchInfo.allocate_num_start !== "") {
        option.allocate_num_start = this.searchInfo.allocate_num_start;
      }
      if (this.searchInfo.allocate_num_end !== "") {
        option.allocate_num_end = this.searchInfo.allocate_num_end;
      }
      if (
        this.searchInfo.allocate_time &&
        this.searchInfo.allocate_time.length === 2
      ) {
        option.allocate_start_time = this.searchInfo.allocate_time[0];
        option.allocate_end_time = this.searchInfo.allocate_time[1];
      }
      if (
        this.searchInfo.follow_time &&
        this.searchInfo.follow_time.length === 2
      ) {
        option.follow_start_time = this.searchInfo.follow_time[0];
        option.follow_end_time = this.searchInfo.follow_time[1];
      }
      if (this.searchInfo.appear_id !== "") {
        option.appear_id = this.searchInfo.appear_id;
      }
      if (this.searchInfo.source_type !== "") {
        option.source_type = this.searchInfo.source_type;
      }
      if (this.searchInfo.last_follow_staff_id !== "") {
        option.last_follow_staff_id = this.searchInfo.last_follow_staff_id;
      }
      if (this.searchInfo.date && this.searchInfo.date.length === 2) {
        option.start_time = this.searchInfo.date[0].getTime() / 1000;
        option.end_time =
          this.searchInfo.date[1].getTime() / 1000 + (24 * 60 * 60 - 1);
      }
      if (this.searchInfo.intent_arr.length > 0) {
        option.intent_arr = this.searchInfo.intent_arr;
      }
      if (this.searchInfo.age_stage !== "") {
        option.age_stage = this.searchInfo.age_stage;
      }
      if (this.searchInfo.follow_status.length > 0) {
        option.follow_status = this.searchInfo.follow_status;
      }
      if (this.searchInfo.market_staff_id !== "") {
        option.market_staff_id = this.searchInfo.market_staff_id;
      }
      if (this.searchInfo.create_staff_id !== "") {
        option.create_staff_id = this.searchInfo.create_staff_id;
      }
      return option;
    },
    handleExport() {
      let option = this.solveSearchParams();
      exportWaitingStudentListApi(option).then((res) => {
        exportLoop(res.data.task_id);
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        ...this.solveSearchParams(),
      };
      if (
        this.searchInfo.sort_type !== "" &&
        this.searchInfo.sort_field !== ""
      ) {
        option.sort_type = this.searchInfo.sort_type;
        option.sort_field = this.searchInfo.sort_field;
      }
      getWaitingStudentListApi(option).then((res) => {
        res.data.list = res.data.list || [];
        this.page = res.data.page;
        this.total = res.data.total;
        const today = new Date().getTime();
        res.data.list.map((item) => {
          if (item.follow_log) {
            item.follow_log_content = item.follow_log.content || "-";
          } else {
            item.follow_log_content = "-";
          }
          if (item.create_time) {
            item.create_time = dateFormat(
              "YYYY-mm-dd",
              item.create_time * 1000
            );
          } else {
            item.create_time = "-";
          }
          if (item.allocate_time) {
            item.allocate_time = dateFormat(
              "YYYY-mm-dd",
              item.allocate_time * 1000
            );
          } else {
            item.allocate_time = "-";
          }
          if (item.follow_time) {
            item.follow_time = dateFormat(
              "YYYY-mm-dd",
              item.follow_time * 1000
            );
          } else {
            item.follow_time = "-";
          }
          if (item.age === 0) {
            if (item.birthday !== 0) {
              const severalMonths = today - item.birthday * 1000;
              item.age = new Date(severalMonths).getMonth() + "个月";
            } else {
              item.age = "-";
            }
          } else {
            item.age = item.age + "岁";
          }
        });
        this.tableData = res.data.list;
        if (res.data.page > 1 && res.data.list.length === 0) {
          this.handleSearch();
        }
        this.savePageInfo();
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    toStudentDetail(row) {
      this.$router.push({
        name: "studyDetails",
        query: { id: row.student_id, tab: "followup", from: "waiting_student" },
      });
    },
    savePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "recruitWaitingList",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitWaitingList",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitWaitingList",
        key: "search_info",
        value: this.searchInfo,
      });
    },
    beforeDestroy() {
      eventBus.$off("latent-list-update-waiting");
    },
    showFilterDialog() {
      this.columnFilter.map((item, index) => {
        this.columnFilterCopy[index]
          ? (this.columnFilterCopy[index].active = item.active)
          : "";
      });
      this.filterDialogVisible = true;
    },
    handleFilterDialogCancel() {
      this.filterDialogVisible = false;
    },
    handleFilterDialogSubmit() {
      let activeList = this.columnFilterCopy.filter((item) => {
        return item.active;
      });
      if (activeList.length === 0) {
        this.$message({
          message: "请选择列表数据",
          type: "warning",
        });
        return false;
      }
      this.columnFilterCopy.map((item, index) => {
        this.columnFilter[index].active = item.active;
      });
      this.filterDialogVisible = false;
      this.$nextTick(() => {
        let tableEl = this.$refs["main-table"];
        tableEl.doLayout();
      });
      // 保存参数
      localStorage.setItem(
        "ts-latent-waiting-data-filter-params",
        JSON.stringify({
          filter: this.columnFilter,
          copy: this.columnFilterCopy,
        })
      );
    },
    handleMultiClaim() {
      let ids = this.multipleSelection.map((s) => {
        return s.id;
      });
      if (!ids || ids.length === 0) {
        return false;
      }
      this.$confirm(
        `确定对选中${ids.length}个学员认领吗？认领后，归属为你的意向学员，负责跟进`,
        `批量认领`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          claimWaitingStudentApi({
            student_ids: ids,
          }).then((res) => {
            if (res.data.fail_total > 0) {
              this.$message({
                type: "error",
                message: res.data.fail_message,
              });
            } else {
              this.$message({
                type: "success",
                message: "认领成功",
              });
            }
            this.handleRefresh();
          });
        })
        .catch(() => {});
    },
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearch();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.header-btns {
  margin-bottom: 12px;
  position: relative;
  .btn {
    margin-right: 20px;
    display: inline-block;
  }
  .filter-button {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
    display: flex;
    cursor: pointer;
    align-items: center;
    .icon {
      width: 22px;
      height: 22px;
      margin-right: 6px;
    }
    p {
      color: #333;
      font-size: 14px;
      line-height: 16px;
      &.small {
        font-size: 12px;
        color: #999;
      }
    }
  }
}
.table-btns {
  .el-button {
    margin: 0 4px;
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
.allocate-wrap {
  display: flex;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  line-height: 30px;
  height: 30px !important;
  position: relative;
  .el-input {
    width: 165px;
  }
  /deep/.el-input__inner {
    border: none !important;
  }
  span {
    margin: 0 10px 0 0;
  }
  .el-input {
    width: auto;
    text-align: center;
  }
}
</style>
